
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/zdorovru",
      function () {
        return require("private-next-pages/zdorovru.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/zdorovru"])
      });
    }
  